//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head () {
    return {
      title:
        'Manchester Pest Control | Identify Woodlice | Woodlice Control Manchester',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Identify, and treat Woodlice in the Manchester, Stockport and Cheshire regions.'
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: 'Manchester Pest Control | Identify Woodlice | Woodlice Control Manchester'
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: 'Identify, and treat Woodlice in the Manchester, Stockport and Cheshire regions.'
        }
      ]
    }
  }
}
